import React from 'react';
import type { EventSeverity, EventStatus, EventCategory } from '../../types';
import './EventFilterBar.css';

export interface EventFilterBarProps {
  /** Currently selected severity filter (null = all) */
  selectedSeverity: EventSeverity | null;
  /** Currently selected status filter (null = all) */
  selectedStatus: EventStatus | null;
  /** Currently selected category filter (null = all) */
  selectedCategory: EventCategory | null;
  /** Callback when severity filter changes */
  onSeverityChange: (severity: EventSeverity | null) => void;
  /** Callback when status filter changes */
  onStatusChange: (status: EventStatus | null) => void;
  /** Callback when category filter changes */
  onCategoryChange: (category: EventCategory | null) => void;
  /** Optional custom className */
  className?: string;
}

const SEVERITY_OPTIONS: { value: EventSeverity | null; label: string }[] = [
  { value: null, label: 'Alle' },
  { value: 'action_required', label: 'Handlungsbedarf' },
  { value: 'warning', label: 'Warnungen' },
  { value: 'info', label: 'Info' },
];

const STATUS_OPTIONS: { value: EventStatus | null; label: string }[] = [
  { value: null, label: 'Alle' },
  { value: 'new', label: 'Neu' },
  { value: 'acknowledged', label: 'Bestätigt' },
  { value: 'resolved', label: 'Erledigt' },
  { value: 'dismissed', label: 'Zurückgestellt' },
];

const CATEGORY_OPTIONS: { value: EventCategory | null; label: string }[] = [
  { value: null, label: 'Alle' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'lifecycle', label: 'Lebenszyklus' },
  { value: 'reconciliation', label: 'Abgleich' },
  { value: 'general', label: 'Allgemein' },
];

export const EventFilterBar: React.FC<EventFilterBarProps> = ({
  selectedSeverity,
  selectedStatus,
  selectedCategory,
  onSeverityChange,
  onStatusChange,
  onCategoryChange,
  className = '',
}) => {
  return (
    <div className={`event-filter-bar ${className}`.trim()}>
      <div className="event-filter-bar__group">
        {SEVERITY_OPTIONS.map((opt) => (
          <button
            key={opt.label}
            className={`event-filter-bar__btn ${selectedSeverity === opt.value ? 'event-filter-bar__btn--active' : ''}`}
            onClick={() => onSeverityChange(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
      <div className="event-filter-bar__group">
        <select
          className="event-filter-bar__select"
          value={selectedStatus ?? ''}
          onChange={(e) =>
            onStatusChange((e.target.value || null) as EventStatus | null)
          }
        >
          {STATUS_OPTIONS.map((opt) => (
            <option key={opt.label} value={opt.value ?? ''}>
              {opt.label}
            </option>
          ))}
        </select>
        <select
          className="event-filter-bar__select"
          value={selectedCategory ?? ''}
          onChange={(e) =>
            onCategoryChange(
              (e.target.value || null) as EventCategory | null,
            )
          }
        >
          {CATEGORY_OPTIONS.map((opt) => (
            <option key={opt.label} value={opt.value ?? ''}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default EventFilterBar;
